import { NAME } from './constants';
import { router } from './router';
import { apiProvider } from './api';
import * as constants from './constants';

export const CasovaUdalost = {
	name: NAME,
	router,
	apiProvider,
	constants,
};
